import $ from 'jquery';
import axios from 'axios';

const jsrender = require('jsrender')($);

$(document).ready(function () {
  const $priceSimulator = $('.m-price-simulator');
  const $form = $priceSimulator.find('form');
  const pricesSimulatorTmpl = jsrender.templates('#pricesSimulatorTmpl');
  const $simulatedPrices = $priceSimulator.find('.simulated-prices');
  const $radios = $form.find('.e-radiobutton input');

  //
  const getPrices = () => {
    const params = {};

    // Serialize form in an object
    $form.serializeArray().map(function(x){ params[x.name] = x.value; });

    // Call the API
    axios.get(API['API_SIMULATOR'], {
      params
    }).then(function(response) {
      const object = Object.assign({}, response.data, params);
      const html = pricesSimulatorTmpl.render(object);
      $simulatedPrices.html(html);
    });
  };

  if ($priceSimulator.length > 0) {
    // First API call with default params
    getPrices();

    $radios.on('change', () => getPrices());
  }
});



// WEBPACK FOOTER //
// ./app/ui/modules/price-simulator/index.js